export default {
  publicQuestions: [],
  pagination: {
    total: 0,
    count: 0,
    per_page: 20,
    current_page: 1,
    total_pages: 0
  },
  publicQuestion: {}
}
